{
  "alert": "Brīdinājums",
  "dismiss": "Nerādīt"
}